<template>
  <v-container fluid>
      <v-row>
        <v-col>
          <BoardersTable
            v-if="boardersTable"
            :user="currentUser"
            :institution-diets="availableDiets"
            :boarders="boarders"
            class="mb-4"
          ></BoardersTable>
          <BoarderOrdersByDate
            v-if="boardersTable"
            :boarders="boarders"/>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import BoardersTable from '../../components/BoardersTable'
import { mapGetters } from 'vuex'
import BoarderOrdersByDate from '../../components/BoarderOrdersByDate'
export default {
  name: 'Institution',
  components: { BoarderOrdersByDate, BoardersTable },
  data () {
    return {
      institution: {
      },
      availableDiets: [],
      search: '',
      boarders: [],
      boardersTable: false
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'user/currentUser' })
  },
  methods: {
    initialize () {
      this.getBoarders()
      this.institution.id = this.currentUser.institutionId
      this.initializeDiets()
    },
    initializeDiets () {
      this.$http.get('/admin/diets')
        .then(response => {
          this.availableDiets = this.keysToCamelCase(response.data)
            .filter(diet => diet.dietType === 'Instituční' && diet.active)
        })
        .catch(err => console.log(err))
    },
    getBoarders () {
      this.boardersTable = false
      this.$http.get(`/admin/user/${this.currentUser.id}/boarders`)
        .then(response => {
          this.boarders = this.keysToCamelCase(response.data)
            .map(boarder => {
              boarder.loggableStr = boarder.email ? 'Ano' : 'Ne'
              boarder.diet = boarder.diets[0]
              boarder.name = `${boarder.firstName} ${boarder.lastName}`
              return boarder
            })
          this.boardersTable = true
        })
        .catch(err => console.log(err))
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>

</style>
